// import { useEffect, useState } from "react"

import { Page, Text, View, Document } from '@react-pdf/renderer';

import { styles } from './styles/styles';
import { Header } from './common/header';
import { FooterStyle2 } from "./common/footer"
import { BodyTopStyle2 } from './common/bodyTop';
import { BodyMainHeaderStyle1 } from './common/bodyMainHeader';
import { BodyMainFooterStyle1 } from './common/bodyMainFooter';
import { BodyMainRowStyle1 } from './common/bodyMainRow';

// config
const _documentLabel = "DELIVERY ORDER";

const RenderBodyMain = ({ routeType, pageNumber, totalPages, data, document, summary }) => {

    return (
        <View
            style={{
                fontWeight: 800
            }}
        >
            <BodyMainHeaderStyle1 />
            <View>
                {
                    data.map((i, index) => {
                        return <BodyMainRowStyle1 key={index} row={i} index={index} />
                    })
                }
            </View>
            {
                (pageNumber === totalPages) &&
                <BodyMainFooterStyle1 document={document} data={data} summary={summary} />
            }
        </View>
    )
}

const RenderHeader = (props) => {

    const { document, header } = props;

    return (
        <Header
            {...props}
            document={{
                header,
                documentName: _documentLabel,
                documentNumber: document?.doc_number
            }}
        />
    )
}

const RenderPage = ({ routeType, pageNumber, totalPages, qrCodeData, data, document, header, summary }) => {
    return (
        <Page size="A4" style={styles.page} wrap>
            <View render={(props) => <RenderHeader {...props} document={document} header={header} />} fixed />
            <BodyTopStyle2 pageNumber={pageNumber} qrCodeData={qrCodeData} totalPages={totalPages} document={document} />
            <RenderBodyMain pageNumber={pageNumber} totalPages={totalPages} document={document} data={data} summary={summary} />
            <FooterStyle2 document={document} />
        </Page>
    )
}

export function Output({ routeType, document, data, account }) {

    const { document: _document, items: _items, document_header: _documentHeader, qrCodeData } = data;

    const rowPerPage = 12;

    // calculate total pages
    const totalPages = Math.floor(_items.length / rowPerPage);

    let array = [];

    for (let i = 0; i <= totalPages; i += 1) {
        array.push(i)
    }

    // calculate total summary
    const totalQty = _items.reduce((total, val) => total + parseFloat(val?.qty), 0)

    const summary = {
        totalQty
    }

    return (
        <Document
            title={document?.title}
        >
            {
                array.map((i, index) => {

                    const startFrom = index === 0 ? 0 : index * rowPerPage
                    const startTo = index === 0 ? rowPerPage : startFrom + rowPerPage

                    // slide the needed array subset data
                    const data = _items.slice(startFrom, startTo)

                    return (
                        <RenderPage
                            routeType={routeType}
                            pageNumber={(i + 1)}
                            totalPages={array.length}
                            account={account}
                            qrCodeData={qrCodeData}
                            document={_document}
                            header={_documentHeader}
                            data={data}
                            key={index}
                            summary={summary}
                        />
                    )
                })
            }
        </Document>
        // <div>Hello World</div>
    )
}